export const SiteInfo = {
  siteName: 'Prosense',
  koreanName: '프로센스',
  tagline: 'AliExpress 핫딜 큐레이션',
  description: '할인율, 판매량, 리뷰 신호를 바탕으로 AliExpress 인기 상품과 프로모션을 선별하는 데이터 기반 핫딜 큐레이션입니다.',
  primaryKeywords: [
    '알리 핫딜',
    '알리핫딜',
    '알리익스프레스 핫딜',
    'AliExpress 핫딜',
    '알리익스프레스 프로모션',
    'AliExpress 프로모션',
    '알리 쿠폰',
    '알리 세일',
    '해외직구',
  ],
  supportEmail: 'prosense@prosense.co.kr',
  gaMeasurementId: 'G-WPY9DD8QW9',
  theme: 'light',
  adsenseClient: 'ca-pub-6653791084583982',
};
